export default class ScrollAnchor {
    static init(): void {

        window.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;

            if (target.classList.contains('scroll-anchor')) {
                e.preventDefault();
                const href = target.getAttribute('href');
                if (href) {
                    const section = document.getElementById(href.replace('#', ''));
                    if (section) {
                        section.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start',
                            inline: 'nearest'
                        });
                    }
                }
            }

        });

    }
}
